import { useMutation, type FetchResult } from "@apollo/client";

import type {
  SyncShadowMutation,
  SyncShadowMutationVariables,
} from "../../../API";
import { SYNC_SHADOW } from "../../../common/operations/mutations";

interface SyncShadowInterface {
  syncShadowsForNode: (
    nodeId: string
  ) => Promise<FetchResult<SyncShadowMutation>>;
  data?: SyncShadowMutation | null;
  loading: boolean;
}

export const useSyncShadow = (): SyncShadowInterface => {
  const [syncShadow, { data, loading }] = useMutation<
    SyncShadowMutation,
    SyncShadowMutationVariables
  >(SYNC_SHADOW);

  const syncShadowsForNode = async (
    nodeId: string
  ): Promise<FetchResult<SyncShadowMutation>> => {
    if (!nodeId) return { data: null };

    const normalizedNodeId = nodeId.startsWith("C_")
      ? nodeId.replace("C_", "C#").replace("_L_", "#L#").replace("_N_", "#N#")
      : nodeId;

    return await syncShadow({
      variables: {
        nodeId: normalizedNodeId,
      },
    });
  };

  return { syncShadowsForNode, data, loading };
};
